import { useVirgil } from '@contexts/VirgilContext';
import Message from './Message';

const MessageHistory = () => {
  const { messageHistory } = useVirgil();
  return messageHistory.map((message, index) => <Message message={message} key={index} />);
};

export default MessageHistory;
